<template>
  <VenueDetail />
</template>

<script>

import VenueDetail from "@/components/venue/VenueDetail.vue";

export default {
  name: 'VenueDetailView',
  components: {VenueDetail}
}
</script>

<style lang="scss" scoped>
</style>
